var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from './drivers/framework/Timeouts';
export class DeferredMerge {
    constructor(timeoutMs, timeouts) {
        this.timeoutMs = timeoutMs;
        this.timeouts = timeouts !== null && timeouts !== void 0 ? timeouts : new Timeouts();
        this.onMergeTimeoutComplete = this.onMergeTimeoutComplete.bind(this);
        this.timeout = this.timeouts.create();
    }
    get isDeferring() {
        return this.timeout.isRunning;
    }
    get isUpdating() {
        return this.state !== undefined;
    }
    get value() {
        return this._value;
    }
    cancel() {
        if (this.state !== undefined) {
            this.state.cancelled = true;
            this.state = undefined;
        }
        this.timeout.clear();
    }
    destroy() {
        this.cancel();
        this.timeout.destroy();
    }
    onComplete(completeCallback) {
        this.completeCallback = completeCallback;
    }
    onMergeTimeoutComplete() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const value = this._value;
            this._value = undefined;
            if (value !== undefined) {
                this.state = { cancelled: false };
                yield this.doMerge(value, this.state);
                this.state = undefined;
                if (this._value === undefined) {
                    (_a = this.completeCallback) === null || _a === void 0 ? void 0 : _a.call(this);
                }
                else {
                    this.scheduleTimeout();
                }
            }
        });
    }
    scheduleTimeout(timeoutMs) {
        if (this.state !== undefined)
            return;
        this.timeout.set(this.onMergeTimeoutComplete, timeoutMs !== null && timeoutMs !== void 0 ? timeoutMs : this.timeoutMs);
    }
    update(value, timeoutMs) {
        this._value = this.merge(value, this._value);
        this.scheduleTimeout(timeoutMs !== null && timeoutMs !== void 0 ? timeoutMs : this.timeoutMs);
    }
}
